import { ChartOfAccountsApiClient, ChartOfAccount } from '@/clients/chartOfAccountsApiClient';

export class ChartOfAccountsService {
  async getChartOfAccounts(): Promise<ChartOfAccount[]> {
    return ChartOfAccountsApiClient.getChartOfAccounts();
  }

  async getAccountByNumber(accountNumber: string): Promise<ChartOfAccount | null> {
    return ChartOfAccountsApiClient.getAccountByNumber(accountNumber);
  }

  async getAccountsByType(accountType: string): Promise<ChartOfAccount[]> {
    return ChartOfAccountsApiClient.getAccountsByType(accountType);
  }

  async getAccountsByStatementType(statementType: string): Promise<ChartOfAccount[]> {
    return ChartOfAccountsApiClient.getAccountsByStatementType(statementType);
  }
}
